import { validationIsEqual } from '../status';
import {
    validateAlphaNumericString,
    validateStreetWithNumber,
    validateEmail,
    validateName,
    validateContactNumber,
    validateSingleSelection,
    validateDate,
    validateNumber,
    validateLoanTerm,
    validatePassportNumber,
    validatePostalAddress,
    validateAlphaString,
    validateAccountNumber,
    validateNumericString,
    validateDateOfBirth,
    OmValidationDateHelper,
} from '@om/validation';

import { validateBwIdNumber } from '@om/validation/src/validators/bw-id-number-validator';
import { setDeceasedDetailsFieldValid } from '../../../actions/sizotsaFuneralClaim/deceasedDetails';
import { validateNameVTwo } from '@om/validation/src/validators/string-validator';
import { getDeceasedDetailsForm } from '../../../selectors/sizotsaFuneralClaim/deceasedDetails';
import { validateDateBW } from '@om/validation/src/validators/date-validator';
import { calculateAge } from '../../../functions/easiplusFuneralPlan/Util';
import { validateSzIdNumber } from '@om/validation/src/validators/eswatini-id-number-validator';

let prevValidationAction = null;

export const deceasedDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        const state = store.getState().roaQuoteTools.digiLifeQuoteTool.form;
        const trimValue = (value) => (value ? value.trim() : value);
        let error;
        const { claimentType, idSelected, title, dateOfBirth } = getDeceasedDetailsForm(store.getState());
        const getTommorowsDate = () => {
            const currentDate = new Date();
            currentDate.setDate(currentDate.getDate());
            const day = currentDate.getDate();
            const month = currentDate.getMonth() + 1;
            const year = currentDate.getFullYear();
            return `${day}/${month}/${year}`;
        };
        switch (action.value.fieldType) {
            // Personal details
            //   case TITLE_SET_VALUE:
            //     error = validateSingleSelection(action.value.value, "Title");
            //     return setTitleValid(error);
            case 'deceasedRelation':
                error = validateSingleSelection(action.value.value, 'Relation with deceased');
                break;
            case 'relationShip':
                error = validateSingleSelection(action.value.value, 'Relationship');
                break;
            case 'title':
                error = validateSingleSelection(action.value.value, 'Title');
                break;
            case 'firstName':
                error = validateNameVTwo(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'First name',
                });
                break;

            case 'middleName':
                error = validateName(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'Middle name',
                    required: false,
                });
                break;
            case 'lastName':
                error = validateNameVTwo(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'Last name',
                });
                break;

            case 'idSelected':
                error = validateSingleSelection(action.value.value, 'Select ID');
                break;
            case 'accountHolderId':
                error =
                    idSelected?.value === '01'
                        ? validateSzIdNumber(action.value.value, {
                              required: true,
                              subject: `'Eswatini ID number`,
                              gender: title?.value === 'Mr.' ? 'Male' : 'Female',
                              dateOfBirth: dateOfBirth?.value,
                          })
                        : validatePassportNumber(action.value.value, {
                              required: true,
                              subject: `'Passport ID number`,
                          });
                break;

            case 'dateOfDeath':
                const minDate=  dateOfBirth?.value !==null ? calculateAge(dateOfBirth?.value) < 3 ? dateOfBirth?.value : '08/01/2022' : '08/01/2022'
                const ageInYears = action.value.value ? calculateAge(action.value.value) : null;
                error =
                    ageInYears >= 3
                        ? 'We are not allowing the claim more than 3 years'
                        : validateDateBW(action.value.value, {
                              min: minDate,
                              max: getTommorowsDate(),
                              subject: 'Date of death',
                              required: true,
                          });
                break;
            case 'dateOfBirth':
                error = validateDateOfBirth(action.value.value, {
                    subject: 'Date of birth',
                    required: true,
                });
                break;
            case 'idNumber':
                error = validateNumericString(action.value.value, {
                    min: 8,
                    max: 9,
                    subject: 'Account holder id',
                });
                break;
            case 'reasonForDelay':
                error = validateAlphaNumericString(action.value.value, {
                    min: 2,
                    max: 25,
                    required: true,
                    subject: 'Reason For delay',
                });
                break;
            case 'placeOfDeath':
                error = validateAlphaNumericString(action.value.value, {
                    min: 2,
                    max: 25,
                    required: true,
                    subject: 'Place of death',
                });
                break;

            case 'cause':
                error = validateSingleSelection(action.value.value, 'Cause Of Death');
                break;
            case 'mentionedCause':
                error = validateAlphaNumericString(action.value.value, { min: 2, max: 25, subject: 'Cause of death' });
                break;

            default:
                error = null;
        }

        return setDeceasedDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
